<script>
/* eslint-disable new-cap,vue/require-default-prop,vue/require-prop-type-constructor */
import { binMethods } from '@state/helpers'
// import store from '@state/store'

export default {
  name: 'AddServiceBin',
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'Add Service Bin',
    meta: [{ name: 'add-service-bin', content: 'Add-service-bin' }],
  },
  props: {
    serviceId : null,
    newBin: false,
  },
  data() {
    return {
      allTheBins: [],
      binType: null,
      binDescriptions:[],
      newServiceBin: {
        binId: null,
        serviceId: null,
        price:null,
        binIdentifier:null,
        defaultPricing: true,
        issueDate: null,
        weeklyMaintenanceFee: null,
        chargePerTonne: false,
        chargePerLitre: false,
        weightAllowed: 0,
        extraPrice: 0,
      },
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.getBins().then(response => {
      let bin = this.$store.state.bins.objects
      for (var bi in bin) {
        this.binDescriptions.push(`${bin[bi].description}: ${bin[bi].name}`)
        this.allTheBins.push(bin[bi])
      }
    })
  },
  methods: {
    ...binMethods,
    submit(serviceId) {
      this.$validator.validateAll()
      this.addBin(serviceId)
    },
    async addBin(serviceId) {
      await this.$validator.validateAll().then((response) => {
        // console.log(response)
        if(response){
          let moment = require('moment');
          let today = moment.utc().toISOString()

          let binName = this.binType
          let bindex = this.binDescriptions.indexOf(binName)

          this.newServiceBin.binId = parseInt(this.allTheBins[bindex].id)
          this.newServiceBin.serviceId = parseInt(serviceId)
          this.newServiceBin.issueDate = today

          if(this.newServiceBin.price){
            this.newServiceBin.price = parseInt(this.newServiceBin.price * 100)
            this.newServiceBin.defaultPricing = false
          }

          if(this.newServiceBin.weeklyMaintenanceFee) {
            this.newServiceBin.weeklyMaintenanceFee = parseInt(this.newServiceBin.weeklyMaintenanceFee * 100)
          }

          if(this.newServiceBin.weightAllowed) {
            this.newServiceBin.weightAllowed = parseFloat(this.newServiceBin.weightAllowed)
          }

          if(this.newServiceBin.extraPrice){
            this.newServiceBin.extraPrice = parseInt(this.newServiceBin.extraPrice * 100)
          }
          this.addBinToService(this.newServiceBin).then(d => {
            this.newBin = !this.newBin
            location.reload()
          })
        }
      })
    },
  },
}
</script>

<template>
  <div>
    <VContainer>
      <!-- ADD Service Bin MODAL -->
      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="newBin"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <VFlex xs12>
                  <h3>Add Bin to Service</h3>
                </VFlex>
                <VFlex xs12>
                  <VAutocomplete
                    v-model="binType"
                    v-validate="'required'"
                    :error-messages="errors.collect('bin_type')"
                    data-vv-name="bin_type"
                    :items="binDescriptions"
                    label="Bin Type"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                  />
                </VFlex>
                <VFlex xs12>
                  <VTextField
                    v-model="newServiceBin.price"
                    v-validate="'required'"
                    :error-messages="errors.collect('service_fee')"
                    data-vv-name="service_fee"
                    type="number"
                    label="Service fee"
                    prefix="$"
                    required
                    :menu-props="{ absolute: true }"
                  />
                </VFlex>
                <VFlex xs12>
                  <VTextField
                    v-model="newServiceBin.weeklyMaintenanceFee"
                    v-validate="'required'"
                    :error-messages="errors.collect('maintenance_fee')"
                    data-vv-name="maintenance_fee"
                    type="number"
                    label="Maintenance fee"
                    required
                    prefix="$"
                    :menu-props="{ absolute: true }"
                  />
                </VFlex>
                <VFlex xs12>
                  <VTextField
                    v-model="newServiceBin.binIdentifier"
                    v-validate="'required'"
                    :error-messages="errors.collect('bin_identifier')"
                    data-vv-name="bin_identifier"
                    label="Bin Identifier"
                    required
                    :menu-props="{ absolute: true }"
                  />
                </VFlex>
                <VFlex xs12>
                  <VTextField
                    v-model="newServiceBin.issueDate"
                    v-validate="'required'"
                    :error-messages="errors.collect('issue_date')"
                    data-vv-name="issue_date"
                    label="Issue Date"
                    type="date"
                    required
                    :menu-props="{ absolute: true }"
                  />
                </VFlex>
                <VLayout>
                  <VFlex xs6>
                    <VCheckbox
                      v-model="newServiceBin.padlocks"
                      label="Padlocks"
                    />
                  </VFlex>
                  <VFlex xs6>
                    <VCheckbox
                      v-model="newServiceBin.castors"
                      label="Castors"
                    />
                  </VFlex>
                </VLayout>
                <VLayout>
                  <VFlex xs6>
                    <VTextField
                      v-model="newServiceBin.weightAllowed"
                      v-validate="'required'"
                      :error-messages="errors.collect('weight_allowed')"
                      data-vv-name="weight_allowed"
                      type="number"
                      label="Weight Allowed"
                      required
                      :menu-props="{ absolute: true }"
                    />
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="newServiceBin.extraPrice"
                      v-validate="'required'"
                      :error-messages="errors.collect('extra_price')"
                      data-vv-name="extra_price"
                      type="number"
                      label="Extra Price"
                      required
                      :menu-props="{ absolute: true }"
                      prefix="$"
                    />
                  </VFlex>
                </VLayout>
                <VLayout
                  row
                  wrap
                >
                  <VFlex xs6>
                    <VCheckbox
                      v-model="newServiceBin.chargePerTonne"
                      label="Charge per Tonne"
                    />
                  </VFlex>
                  <VFlex xs6>
                    <VCheckbox
                      v-model="newServiceBin.chargePerLitre"
                      label="Charge per Litre"
                    />
                  </VFlex>
                </VLayout>
                <VLayout>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="newBin = !newBin"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      @click.native="addBin(serviceId)"
                    >
                      Save
                    </VBtn>
                  </VFlex>
                </VLayout>
      </vcontainer></vcardtext></vcard></vdialog></VLayout>
    </VContainer>
  </div>
</template>

<style lang="scss" module>
    @import '@design';

    .routeHeader {
        display: inline-block;
    }

    .addButton {
        display: inline-block;
        float: right;
    }
</style>
